import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import { useAdvanceTableContext } from 'providers/AdvanceTableProvider';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

const AdvanceTable = ({
  headerClassName,
  bodyClassName,
  rowClassName,
  tableProps,
  rowProps,
  onRowClick
}) => {
  const table = useAdvanceTableContext();
  const { getRowModel, getPaginationRowModel, getFlatHeaders } = table;

  // Usar getPaginationRowModel si está disponible, sino usar getRowModel
  const rowModel = getPaginationRowModel ? getPaginationRowModel() : getRowModel();

  return (
    <div className="table-responsive scrollbar">
      <Table {...tableProps}>
        <thead className={headerClassName}>
          <tr>
            {getFlatHeaders().map(header => {
              return (
                <th
                  key={header.id}
                  {...header.column.columnDef.meta?.headerProps}
                  className={classNames(
                    'fs-10',
                    header.column.columnDef.meta?.headerProps?.className,
                    {
                      sort: header.column.getCanSort(),
                      desc: header.column.getIsSorted() === 'desc',
                      asc: header.column.getIsSorted() === 'asc'
                    }
                  )}
                  onClick={header.column.getToggleSortingHandler()}
                >
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className={bodyClassName}>
          {rowModel.rows.map(row => {
            // Combinar props de fila con props personalizadas
            const dynamicRowProps = typeof rowProps === 'function' ? rowProps(row) : {};
            const combinedRowProps = {
              ...dynamicRowProps,
              className: classNames(rowClassName, dynamicRowProps.className),
              onClick: onRowClick ? (e) => onRowClick(row, e) : undefined
            };

            return (
              <tr key={row.id} {...combinedRowProps}>
                {row.getVisibleCells().map(cell => (
                  <td key={cell.id} {...cell.column.columnDef.meta?.cellProps}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

AdvanceTable.propTypes = {
  headerClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  rowClassName: PropTypes.string,
  tableProps: PropTypes.object,
  rowProps: PropTypes.func,
  onRowClick: PropTypes.func
};

export default AdvanceTable; 